import { useState } from 'react'
import { Input, Typography, Switch } from 'antd'
import ModelDialog from '@/components/ModelDialog'
import { useFeedback } from '@/utils/antdApp'

const { Text } = Typography

interface AddStockPoolDialogProps {
    open: boolean
    onCancel: () => void
    onAdd: (data: { name: string; description: string; is_favorite: boolean }) => void
    title?: string
}
export default function AddStockDialog({
    open,
    onCancel,
    onAdd,
}: AddStockPoolDialogProps) {
    const { message } = useFeedback()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [is_favorite, setIsFavorite] = useState(false)
    // const [activeColor, setActiveColor] = useState(colors[0])

    const addPool = () => {
        if(!name) return message.warning('请输入股票池名称')
        onAdd({name, description, is_favorite})
    }

    // const handleColorClick = (color: string) => {
    //     setActiveColor(color)
    // }

    return (
        <ModelDialog
            open={open}
            onCancel={onCancel}
            onSure={addPool}
            title = '新建股票池'
            sureText='创建'
        >
            <div className='add-stock-dialog-content'>
                <div style={{ marginBottom: 16 }}>
                    <Text className='text-12 color-2'>
                        股票池名称*
                    </Text>
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="例：新能源赛道、科技成长..."
                        allowClear
                        size="large"
                        styles={{
                            root: {
                                marginTop: 8,
                                marginBottom: 16,
                            },
                            input: {
                                color: '#fff',
                                fontSize: 12,
                            },
                        }}
                    />
                    <Text className='text-12 color-2'>
                        描述
                    </Text>
                    <Input.TextArea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="剪短描述投研逻辑或行业范围"
                        allowClear
                        size="large"
                        rows={2}
                        styles={{
                            root: {
                                marginTop: 8,
                                marginBottom: 16,
                            },
                            textarea: {
                                fontSize: 12,
                            }
                        }}
                    />
                    <Text className='text-12 color-2'>
                        是否关注
                    </Text>
                    <Switch value={is_favorite} size='small' style={{ marginLeft: 10 }} onChange={(checked) => setIsFavorite(checked)} />
                    {/*<Text className='text-12 color-2'>
                        标签颜色
                    </Text>
                     <Flex gap={8} style={{ marginTop: 10 }}>
                        {colors.map((color, index) => (
                            <div 
                            key={index} 
                            style={{ width: activeColor === color ? 28 : 24, height: activeColor === color ? 28 : 24, backgroundColor: color, borderRadius: 50 ,border: activeColor === color ? `2px solid #fff` : 'none'}}
                            onClick={() => handleColorClick(color)}
                            ></div>
                        ))}  
                    </Flex> */}
                    
                </div>
            </div>
        </ModelDialog>
    )
}
